import {Avatar} from '@mui/material';

const avatarSx = {
  height: 56,
  width: 56,
  mr: 2,
  bgcolor: 'secondary.main'
};

export default function NewConditionAvatar() {
  return (
    <Avatar variant="rounded" sx={avatarSx}>
      +
    </Avatar>
  );
}
